import React, { useState } from "react";
import Title from "../layout/Title";
import Education from "./Education";
import Skills from "./Skills";
import Experience from "./Experience";

const Resume = () => {
  const [educationData, setEducationData] = useState(true);
  const [skillData, setSkillData] = useState(false);
  const [experienceData, setExperienceData] = useState(false);

  return (
    <section id="resume" className="w-full py-20 border-b border-b-black">
      <div className="max-w-[1200px] mx-auto px-4">
        <div className="flex justify-center items-center text-center mb-10">
          <Title title="4 + YEARS OF EXPERIENCE" des="My Resume" />
        </div>

        <ul className="w-full grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 mb-10">
          <li
            onClick={() => {
              setEducationData(true);
              setSkillData(false);
              setExperienceData(false);
            }}
            className={`resumeLi ${
              educationData ? "border-designColor rounded-lg" : "border-transparent"
            }`}
          >
            Education
          </li>
          <li
            onClick={() => {
              setEducationData(false);
              setSkillData(true);
              setExperienceData(false);
            }}
            className={`resumeLi ${
              skillData ? "border-designColor rounded-lg" : "border-transparent"
            }`}
          >
            Professional Skills
          </li>
          <li
            onClick={() => {
              setEducationData(false);
              setSkillData(false);
              setExperienceData(true);
            }}
            className={`resumeLi ${
              experienceData ? "border-designColor rounded-lg" : "border-transparent"
            }`}
          >
            Experience
          </li>
        </ul>

        {/* Render selected tab component */}
        {educationData && <Education />}
        {skillData && <Skills />}
        {experienceData && <Experience />}
      </div>
    </section>
  );
};

export default Resume;
